import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/themetwo/calander.png'


const _hoisted_1 = { class: "cardContainer" }
const _hoisted_2 = { class: "dayTitle" }
const _hoisted_3 = { style: {"color":"#ffdcfb"} }
const _hoisted_4 = { class: "valueText" }
const _hoisted_5 = { style: {"font-weight":"100","color":"#c19a6b"} }
const _hoisted_6 = { class: "dayTitle" }
const _hoisted_7 = { class: "valueText" }
const _hoisted_8 = {
  key: 1,
  class: "glowing-line"
}
const _hoisted_9 = {
  class: "dateText",
  style: {"font-size":"14px"}
}
const _hoisted_10 = {
  class: "dayTitle",
  style: {"font-size":"16px"}
}
const _hoisted_11 = { style: {"padding-left":"10px","color":"#ffdcfb","font-weight":"bold"} }
const _hoisted_12 = {
  class: "statusRow",
  style: { color: 'var(--status-color)' }
}
const _hoisted_13 = { style: {"font-weight":"bold"} }
const _hoisted_14 = { class: "detailedCardContent" }
const _hoisted_15 = { style: {"color":"#ffdcfb","padding":"0 3px"} }
const _hoisted_16 = {
  class: "statusRow",
  style: { color: 'var(--status-color)' }
}
const _hoisted_17 = { style: {"color":"#ffdcfb"} }
const _hoisted_18 = { style: {"font-weight":"bold"} }

import { checkDate, dayFormat, formatCurrency, } from '@/utils/commonFunction';
import { getAmountSum } from '@/view/components/supportFunction';
import { PropType, computed } from 'vue';
import { useI18n } from 'vue-i18n';
type StatusKey = number;

export default /*@__PURE__*/_defineComponent({
  __name: 'cashBackHistoryCard',
  props: {
    dayCount: {
        type: Number,
    },
    dayList: {
        type: Array as PropType<(any)[]>,
        default: () => []
    },
    createTime: {
        type: String,
        default: () => ""
    },
    availableAmount: {
        type: Number,
        default: () => 0
    },
    title: {
        type: String,
        default: () => ""
    },
    totalAmount: {
        type: Number,
        default: () => 0
    },
    activityStatus: {
        type: Number
    },
    istodayClaimed: {
        type: Boolean,
        default: () => false
    },
    isShowDetails: {
        type: Boolean,
        default: () => true
    },
    givenAmount: {
        type: Number,
        default: () => 0
    },
},
  setup(__props) {

const { t } = useI18n();

const props = __props

const statusMap: Record<StatusKey, { icon: string; text: string; color: string; glow: string }> = {
    0: { icon: 'underway-o', text: 'activityStatus.pending', color: '#3a86ff', glow: '#3a86ff' },
    1: { icon: 'certificate', text: 'activityStatus.completed', color: '#4caf50', glow: '#4caf50' },
    2: { icon: 'close', text: 'activityStatus.noRewards', color: '#f44336', glow: '#f44336' },
    3: { icon: 'close', text: 'activity.overdue', color: '#f44336', glow: '#f44336' }
};
const currentStatus = computed(() => {
    return statusMap[props.activityStatus as StatusKey];
});


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.isShowDetails)
      ? (_openBlock(), _createBlock(_component_van_row, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "3",
              class: "calanderImage"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "",
                  width: "80%"
                }, null, -1)
              ])),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "12",
              class: "topRow"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createTextVNode(_toDisplayString(_ctx.$t('activity.transactionDate')) + ": ", 1),
                  _createElementVNode("span", _hoisted_3, _toDisplayString(__props.createTime?.split(' ')[0]), 1)
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(__props.title) + ": ", 1),
                  _createTextVNode(" " + _toDisplayString(_unref(formatCurrency)(__props.totalAmount)), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "9",
              class: "topRow"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('activity.cashBackTotal')) + ":", 1),
                _createElementVNode("div", _hoisted_7, _toDisplayString(__props.dayList ? _unref(formatCurrency)(_unref(getAmountSum)(__props.dayList)) : _unref(formatCurrency)(0)), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.isShowDetails)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8))
      : _createCommentVNode("", true),
    (!__props.isShowDetails)
      ? (_openBlock(), _createBlock(_component_van_row, { key: 2 }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "7",
              class: "dayColumn"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, _toDisplayString(__props.createTime?.split(' ')[0]), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "17",
              class: "topRow",
              style: {"margin-bottom":"5px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _createTextVNode(_toDisplayString(_ctx.$t('activity.givenAmount')) + " : ", 1),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(formatCurrency)(__props.givenAmount)), 1)
                ]),
                _createVNode(_component_van_row, null, {
                  default: _withCtx(() => [
                    (currentStatus.value)
                      ? (_openBlock(), _createBlock(_component_van_col, {
                          key: 0,
                          span: "24",
                          class: "dayTitle statusBorder",
                          style: _normalizeStyle({
                        '--status-color': currentStatus.value.color,
                        '--status-glow': currentStatus.value.glow
                    })
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_12, [
                              _createVNode(_component_van_icon, {
                                name: currentStatus.value.icon,
                                size: "15px",
                                color: 'var(--status-color)'
                              }, null, 8, ["name"]),
                              _cache[1] || (_cache[1] = _createTextVNode("   ")),
                              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t(currentStatus.value.text)), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["style"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.isShowDetails)
      ? (_openBlock(), _createBlock(_component_van_row, {
          key: 3,
          style: {"margin-top":"10px","display":"flex","justify-content":"center"},
          justify: "space-between"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dayList, (i, index) => {
              return (_openBlock(), _createBlock(_component_van_col, {
                span: "12",
                key: index
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    style: _normalizeStyle({ color: _unref(checkDate)(i.date) == 0 && __props.istodayClaimed ? '#36d836' : _unref(checkDate)(i.date) <= 0 ? 'gray' : '' })
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_van_icon, {
                        name: "point-gift",
                        color: "#ffa1cfbd",
                        size: "16px",
                        style: {"padding-right":"3px"}
                      }),
                      _createTextVNode(" " + _toDisplayString((_unref(dayFormat)(i.date, 0))) + ": ", 1),
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(formatCurrency)(i.amount)), 1)
                    ])
                  ], 4)
                ]),
                _: 2
              }, 1024))
            }), 128)),
            (__props.dayList?.length <= 0 || !__props.dayList)
              ? (_openBlock(), _createBlock(_component_van_col, {
                  key: 0,
                  span: "24",
                  class: "dayTitle statusBorder",
                  style: _normalizeStyle({
                '--status-color': currentStatus.value.color,
                '--status-glow': currentStatus.value.glow, 'margin-bottom': '5px'
            })
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('activity.status')) + " :", 1),
                      _cache[2] || (_cache[2] = _createTextVNode("   ")),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t(currentStatus.value.text)), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["style"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})